import React from 'react';

const getYouTubeVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url?.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
};

const getYouTubeThumbnail = (videoId) => {
    return `https://img.youtube.com/vi/${videoId}/0.jpg`;
};

const AyudaSection = ({ product, setIsOpen }) => {
    const videoId = getYouTubeVideoId(product?.help?.video_id);
    const videoThumbnail = getYouTubeThumbnail(videoId);

    return (
        <div className="tab-pane active" role="tabpanel">
            <h3 className="text-lg font-semibold mb-3">{product?.help?.title}</h3>
            <div className="about-us-img-wrap mb-3 ms-0" style={{ width: 'fit-content', position: 'relative', margin: '0 auto' }}>
                <img src={videoThumbnail} alt="Miniatura de video" />
                <div className="" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto', height: '100%', width: '100%', top: '0', position: 'absolute'}}>
                        <button className="ltn__video-icon-2 ltn__video-icon-2-border---" onClick={() => setIsOpen(true)} style={{ position: 'relative' }}>
                            <i className="fa fa-play" />
                        </button>
                </div>
            </div>
            <p className="mt-2">{product?.help?.description}</p>
        </div>
    );
};

export default AyudaSection;
